import type { ReactElement } from 'react';
import type { ProductRow } from '../grids/ProductsGrid';
import { EntityActivitySection } from '../activity/EntityActivitySection';

type AuthFetch = (url: string, init?: RequestInit) => Promise<Response>;

export function ProductDetailSidePanel({
  item,
  onClose,
  authFetch
}: {
  item: ProductRow;
  onClose: () => void;
  authFetch?: AuthFetch;
}): ReactElement {
  return (
    <aside className="side-panel" data-testid="product-side-panel">
      <button type="button" className="icon-close" onClick={onClose} aria-label="Close">
        ×
      </button>
      <h3>
        <span className="mono-id">{item.code}</span> {item.name}
      </h3>
      <p>
        <span className="status-pill">{item.active ? 'Active' : 'Inactive'}</span> {item.class} · {item.unit} ·{' '}
        {item.defaultSalesAccount}
      </p>
      {authFetch && (
        <EntityActivitySection
          authFetch={authFetch}
          path={`/products/${encodeURIComponent(item.code)}/activity`}
          testId="product-activity"
        />
      )}
    </aside>
  );
}
